import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "timeview" }
const _hoisted_2 = { class: "leftcontent" }
const _hoisted_3 = {
  key: 0,
  class: "bigbox flex v-center center"
}
const _hoisted_4 = {
  key: 1,
  class: "activitybox flex column"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex column grow-1" }
const _hoisted_7 = { class: "flex gap" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = {
  key: 0,
  class: "flex alert"
}
const _hoisted_12 = { class: "copy" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "rightcontent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_selector = _resolveComponent("activity-selector")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_currency = _resolveComponent("currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_activity_selector, {
      validate: "time",
      onOnChange: _ctx.update
    }, null, 8, ["onOnChange"]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { package: _ctx.isPackage }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.activity?.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_loader_display)
            ]))
          : (_ctx.times.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (time) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["ratebox flex v-center", { selected: _ctx.isSelected(time), soldOut: _ctx.isSoldOut(time) }]),
                    key: time.OrderEntityTimeKey ?? 0,
                    onClick: ($event: any) => (_ctx.select(time))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(time.DisplayName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _cache[3] || (_cache[3] = _createTextVNode("Subtotal: ", -1)),
                          _createVNode(_component_currency, {
                            amount: time.SubTotal
                          }, null, 8, ["amount"])
                        ])
                      ])
                    ]),
                    (_ctx.warningFor(time))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "gg-danger" }, null, -1)),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.warningFor(time)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex" }, [
                      _createElementVNode("div", { class: "gg-check big check" }),
                      _createElementVNode("div", { class: "soldOut-box" }, "SOLD OUT")
                    ], -1))
                  ], 10, _hoisted_5))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createTextVNode(" There are no available times for " + _toDisplayString(_ctx.activity?.name) + " on " + _toDisplayString(_ctx.format(_ctx.activity?.selectedDate ?? new Date(), 'eeee, MMM d')) + ". ", 1),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/portal/${_ctx.clientLocationKey}/${_ctx.type}/${_ctx.typekey}/book/date`))),
                  class: "biglink"
                }, "Pick a different date")
              ]))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass(["bookbutton", { broken: !_ctx.canProceed }]),
          onTouchstart: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"])),
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]))
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "gg-arrow-right-o" }, null, -1),
          _createElementVNode("div", null, "NEXT", -1)
        ]), 34)
      ])
    ], 2)
  ]))
}